<template>
  <el-dialog class="wx-dialog" :title="title" :visible.sync="options.show" close="cancel" :width="options.width">
    <div class="gallery-list">
      <ul>
        <li @click="clickPic(item.src)" v-for="item in list" :key="item.id">
          <img :src="item.src" />
        </li>
      </ul>
    </div>
    <div slot="footer" class="footer-dialog-article" style="text-align:center;margin-top:10px">
      <el-button type="success" @click="submit('uiEduction')">返回</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MaterialService from '@/service/api/materialService'
import _ from 'lodash'

export default {
  props: {
    metaData: {
      type: Object,
      default: {}
    },
    cancelFn: {
      type: Function,
      default: () => undefined
    },
    submitFn: {
      type: Function,
      default: () => undefined
    },
    options: {
      type: Object,
      default: {}
    },
    title: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      list: []
    }
  },

  created () {
    this.getMyPic()
  },

  methods: {
    getMyPic () {
      const materialSystem = new MaterialService()
      const obj = {
        m: 'myimage',
        page: 1,
        tag: null
      }
      materialSystem.materialList(obj)
        .then(({ data }) => {
          this.list = data.data
        }, (error) => {
          this.$notify.error(error.message)
        })
    },
    clickPic (val) {
      if (this.submitFn && typeof this.submitFn === 'function') {
        this.submitFn(val)
      }
    },
    submit () {
      this.$destroy()
    },

    cancel () {
      if (this.cancelFn && typeof this.cancelFn === 'function') {
        this.cancelFn()
      }
      this.$destroy()
    }
  },

  destroyed () {
    document
      .getElementById('app')
      .removeChild(this.$el)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .gallery-list{
    margin-top: 20px;
    ul{
      height: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      li{
        max-width: 140px;
        padding: 10px;
        max-height: 110px;
        background: #f2f2f2;
        border-radius: 3px;
        margin-right: 6px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/myGallery.vue